// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39YAO","largestCol":"styles_largestCol__Di1e1","smallestCol":"styles_smallestCol__3ac65"};